module.exports = __webpack_public_path__ + "static/media/masters_thesis6.d7c1f0da.webp";